import { Link } from 'wouter';
import { useCart } from '../providers/CartProvider';
import React, { useState } from 'react';
import CardPaymentModal from './CardPaymentModal';
import useCurrentAccount from "@/hooks/useCurrentAccount.js";

const CheckoutPage = () => {
  const { cart, removeFromCart, updateQuantity, totalPrice, clearCart, shippingTotal, taxTotal, itemTotal } = useCart();
  const { currentAccount } = useCurrentAccount();

  let stripeReturnUrl = window.data_env.stripe_return_url;
  stripeReturnUrl = new URL(stripeReturnUrl);
  stripeReturnUrl.searchParams.set("forward_message", "clearCart");
  stripeReturnUrl = stripeReturnUrl.toString();

  const total = totalPrice();
  const shipping = shippingTotal();

  const modalId = 'cartPaymentModal';

  if (cart.length === 0) {
    return (
      <div className="empty-cart checkout-page">
        <div className="breadcrumbs mb-4">
          <Link to="/">Shop</Link> &gt; View Cart
        </div>
        <div className="mx-auto px-4 text-center">
          <h2 className="mb-4">Your cart is empty</h2>
          <p className="mb-5">Add some products to get started</p>
          <Link
            to="/"
            className="d-inline-block py-3 px-5"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  const paymentLineItems = cart.map((item) => ({
    quantity: item.quantity,
    sales_product_id: item.id,
    gps_shipping: item.gps_shipping
  }));

  return (
    <div className="checkout-page">
      <div className="breadcrumbs mb-4">
        <Link to="/">Shop</Link> &gt; View Cart
      </div>

      <main className="container">
        <div className="row">
          <div className="col-md-8 pe-md-4 mb-md-0 mb-4">
            {cart.map(item => (
              <div key={item.id} className="cart-item-card row p-4 gap-2 mb-2">
                <div className="product-image-wrapper col-3 p-0">
                  <img
                    src={item.sales_square}
                    alt={item.sales_name}
                    className="w-100"
                  />
                </div>

                <div className="d-flex flex-column flex-1">
                  <h3 className="mb-2">{item.sales_name}</h3>
                  <p className="mb-4">${(item.price_usd_cents / 100).toFixed(2)}</p>

                  <div className="d-flex align-items-center gap-3">
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      className="p-2 plus-minus-btn"
                    >
                      <span className="fa fa-minus"></span>
                    </button>
                    <span className="text-center text-large">{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      className="p-2 plus-minus-btn"
                    >
                      <span className="fa fa-plus"></span>
                    </button>
                  </div>
                  <p className="text-end text-large">
                    ${((item.price_usd_cents * item.quantity) / 100).toFixed(2)}
                  </p>
                </div>

                <button
                  onClick={() => removeFromCart(item.id)}
                  className="p-2 remove-from-cart-btn"
                >
                  <span className="fa fa-trash"></span>
                </button>
              </div>
            ))}
          </div>

          <div className="col-md-4 pe-md-0 p-0">
            <div className="order-summary-card p-4">
              <h2 className="mb-4 mt-0">Order Summary</h2>

              <div className="mb-4">
                <div className="d-flex justify-content-between">
                  <span>Subtotal</span>
                  <span>${(itemTotal / 100).toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Shipping</span>
                  <span>{shipping === 0 ? 'FREE' : `$${(shipping / 100).toFixed(2)}`}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Tax</span>
                  <span>${(taxTotal / 100).toFixed(2)}</span>
                </div>
                <div className="pt-3">
                  <div className="d-flex justify-content-between text-xl">
                    <span>Total</span>
                    <span>${(total / 100).toFixed(2)}</span>
                  </div>
                </div>
              </div>

              <button
                onClick={() => {}}
                className="btn site-btn w-100 text-lg"
                data-bs-toggle="modal" data-bs-target={`#${modalId}`}
              >
                Proceed to Payment
              </button>
            </div>
          </div>
        </div>
      </main>

      <CardPaymentModal
        total={total}
        modalId={modalId}
        lineItems={paymentLineItems}
        accountId={currentAccount?.id}
        stripeReturnUrl={stripeReturnUrl}
      />
    </div>
  );
}

export default CheckoutPage;